// The app's banner store: kast-common's createBannerStore (the useBanner API
// the app has always had, one timer per banner keyed by its id), with the
// Settings "Auto-dismiss banner messages" switch read on every show. Outside
// React (the API client) it is used directly; components use useBanner().

import { createBannerStore } from "@jkast90/kast-common/ui";

function autoDismissEnabled(): boolean {
  try {
    return localStorage.getItem("autoDismissBanners") !== "false";
  } catch {
    return true;
  }
}

export const bannerStore = createBannerStore({
  autoDismiss: autoDismissEnabled,
});
